import { graphql } from "../../gql";
import { useQuery } from "@apollo/client";
import { isDefined } from "../../isDefined.ts";

const CalculatePlanGivenSlotQuery = graphql(`
  query calculatePlanGivenSlotByParams(
    $endedAtWeekUtc: String!
    $lessonsPerWeek: Int!
    $startedAtWeekUtc: String!
    $unlimitedLessonPerWeek: UnlimitedLessonPerWeekEnabledInput
  ) {
    calculatePlanGivenSlotByParams(
      endedAtWeekUtc: $endedAtWeekUtc
      lessonsPerWeek: $lessonsPerWeek
      startedAtWeekUtc: $startedAtWeekUtc
      unlimitedLessonPerWeek: $unlimitedLessonPerWeek
    )
  }
`);
export function useCalculatePlanGivenSlot({
  startedAtWeekUtc,
  endedAtWeekUtc,
  lessonsPerWeek,
  unlimitedLessonPerWeek,
}: Partial<{
  startedAtWeekUtc: string;
  endedAtWeekUtc: string;
  lessonsPerWeek: number;
  unlimitedLessonPerWeek?: {
    enabled: boolean;
    totalLessons?: number;
  };
}>) {
  const { data, loading } = useQuery(CalculatePlanGivenSlotQuery, {
    variables: {
      startedAtWeekUtc: startedAtWeekUtc as string,
      endedAtWeekUtc: endedAtWeekUtc as string,
      lessonsPerWeek: lessonsPerWeek as number,
      unlimitedLessonPerWeek: unlimitedLessonPerWeek,
    },
    skip:
      !isDefined(startedAtWeekUtc) ||
      !isDefined(endedAtWeekUtc) ||
      !isDefined(lessonsPerWeek),
    fetchPolicy: "cache-and-network",
  });

  return {
    calculatedGivenSlot: data?.calculatePlanGivenSlotByParams,
    loading,
  };
}
